import React from "react";
import { LeadModalsFragment } from "types/graphql-types";
import { getPrivacyPolicyUrl } from "src/urls/subscribe_newsletter_urls";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import useTimedModal from "components/PageModals/hooks/useTimedModal";
import { match } from "ts-pattern";
import SubscribeToNewsletterPopup from "components/SubscribeToNewsletter/SubscribeToNewsletterPopup/SubscribeToNewsletterPopup";
import { isBlockContentValuePresent } from "@silversea-ssc/ui-components-react";

type TimedModalProps = Omit<LeadModalsFragment, "openingMode"> & {
  sanityPageId: string;
};

const TimedModal: React.FC<TimedModalProps> = ({
  modalContent,
  formDisclaimerSFO,
  defaultContentSFO,
  offersPagePath,
  sanityPageId
}) => {
  const language = useLanguage();
  const { isModalOpen, onRequestClose, onFormSubmitted } = useTimedModal(
    `${modalContent}_${sanityPageId}`
  );

  if (!isModalOpen) return null;

  return (
    <React.Suspense>
      {match(modalContent)
        .with("subscribe_to_newsletter", () => {
          const title = defaultContentSFO?.heading?.title?.localized;

          if (!isBlockContentValuePresent(title)) return null;
          return (
            <SubscribeToNewsletterPopup
              backgroundImage={defaultContentSFO?.backgroundImage}
              subscribeFormContent={{
                headingTitle: title,
                headingContent: defaultContentSFO?.heading?.content?.localized,
                customHeadingTitle:
                  defaultContentSFO?.customPromoHeading?.title?.localized,
                customHeadingContent:
                  defaultContentSFO?.customPromoHeading?.content?.localized
              }}
              formDisclaimerContent={formDisclaimerSFO}
              onRequestClose={onRequestClose}
              onFormSubmitted={onFormSubmitted}
              isOpen={isModalOpen}
              privacyPolicyUrl={getPrivacyPolicyUrl(language.code)}
              offerPageUrl={offersPagePath}
              promoConfigurationCode={
                defaultContentSFO?.promoConfiguration?.code
              }
            />
          );
        })
        .otherwise(() => null)}
    </React.Suspense>
  );
};

export default TimedModal;
